<template>
  <router-view></router-view>
</template>

<script>
import 'regenerator-runtime/runtime'
import { startUiUpdateMonitor } from './utils/uiUpdateMonitor'
import { startAccessManagementUiPolicy } from './utils/accessManagementUiPolicy'

export default {
  name: 'App',

  created () {
    startUiUpdateMonitor(this.$router)
    startAccessManagementUiPolicy(this.$router)
  }
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
